// Lämpökartan väriasteikko. Yksi sävy kasvaa vaaleankeltaisesta tummaan
// magentaan, jotta kerran ja usein kuljettu polku erottuvat myös harmaasävyissä
// ja punavihersokeudessa (kirkkaus nousee jokaisella askeleella).

export const HEAT_STEPS = [
  { min: 1, color: "#f6d98a", label: "1 retki" },
  { min: 2, color: "#eda24a", label: "2" },
  { min: 3, color: "#dd6a34", label: "3–4" },
  { min: 5, color: "#b8236c", label: "5–9" },
  { min: 10, color: "#6f0f59", label: "10 tai enemmän" },
];

/** Askel, johon n retken solu kuuluu. Alle yhden ei piirretä. */
export function heatStep(n) {
  if (n < 1) return null;
  let step = HEAT_STEPS[0];
  for (const s of HEAT_STEPS) if (n >= s.min) step = s;
  return step;
}
